module.exports = __webpack_public_path__ + "239c0de3650bac923dc3a3aa0956204c.png";